/* eslint-disable prettier/prettier */

import React, { useContext } from "react";
import { useTranslation } from 'react-i18next';
import {
  Grid,
  RACModalCard,
  Typography,
  CircularProgress,
} from "@rentacenter/racstrap";
import { reversePaymentStyle } from "../../stylesJS/reversePaymentStyle";
import { GeneralStateContext } from "../../context/GeneralProvider";
export default function DocumentLoading() {
  const { t } = useTranslation('Reverse')
  const classes = reversePaymentStyle();
  const { loadingModal } = useContext(GeneralStateContext);
  const documentLoadingRenderer = () => {
    return (
      <>
        <Grid className={`${classes.textCenter}`}>
          <CircularProgress />
          <Typography
            className={`${classes.textCenter} ${classes.bold} ${classes.mt2} `}
          >
            {t('Fetching Receipts')}
          </Typography>
          <Typography className={`${classes.gridLabel} ${classes.mt2}`}>
            {t('Please wait...')}
          </Typography>
        </Grid>
      </>
    );
  }; // SQ-26 This method will be rendering the loader while fetching receipts.
  return (
    <RACModalCard
      isOpen={loadingModal.document}
      maxWidth="xs"
      borderRadius={"25px !important"}
      //eslint-disable-next-line react/no-children-prop
      children={documentLoadingRenderer()}
    />
  );
}
